export const jiraProjectsOnCreateFixedCacheKey =
  "PostUsersMeJiraIntegrationsProjects-fixed-cache-key";
